import { useTranslation } from 'react-i18next';

import { PartnerDTO } from 'support/types';

type PartnerContext = {
  isCurrentPartnerReceiver?: boolean;
  senderPartner?: PartnerDTO | null;
  receiverPartner?: PartnerDTO | null;
};

type OtherPartnerCopy = {
  title: string;
  description: string;
};

export const useOtherPartnerAnnotationsCopy = (
  context: PartnerContext,
  numberOfErrors: number,
  isLoading: boolean,
): OtherPartnerCopy => {
  const { t } = useTranslation();
  const partner = resolvePartnerRole(context);

  return {
    title: t(`webedi:viewDocument.${partner.role}.noActionRequiredBanner.datachecksError.title`),
    description: isLoading
      ? t('webedi:viewDocument.messageErrorBanner.loadingDatachecks.description')
      : t(`webedi:viewDocument.${partner.role}.noActionRequiredBanner.datachecksError.description`, {
          count: numberOfErrors,
          receiverPartnerName: partner.receiverPartnerName,
          senderPartnerName: partner.senderPartnerName,
          issueResolverName: partner.issueResolverName,
          numberOfFieldsWithErrors: numberOfErrors,
        }),
  };
};

export const useOtherPartnerBlockingCopy = (context: PartnerContext): OtherPartnerCopy => {
  const { t } = useTranslation();
  const partner = resolvePartnerRole(context);

  return {
    title: t(`webedi:viewDocument.${partner.role}.noActionRequiredBanner.title`),
    description: t(`webedi:viewDocument.${partner.role}.noActionRequiredBanner.description`),
  };
};

const resolvePartnerRole = ({ isCurrentPartnerReceiver, senderPartner, receiverPartner }: PartnerContext) => {
  const role: 'receiver' | 'sender' = isCurrentPartnerReceiver ? 'receiver' : 'sender';
  const receiverPartnerName = receiverPartner?.name || '';
  const senderPartnerName = senderPartner?.name || '';
  const issueResolverName = role === 'receiver' ? senderPartnerName : receiverPartnerName;
  return { role, receiverPartnerName, senderPartnerName, issueResolverName };
};

/**
 * i18n keys
 * t('webedi:viewDocument.sender.noActionRequiredBanner.datachecksError.title')
 * t('webedi:viewDocument.sender.noActionRequiredBanner.datachecksError.description', { count })
 * t('webedi:viewDocument.receiver.noActionRequiredBanner.datachecksError.title')
 * t('webedi:viewDocument.receiver.noActionRequiredBanner.datachecksError.description', { count })
 * t('webedi:viewDocument.sender.noActionRequiredBanner.title')
 * t('webedi:viewDocument.sender.noActionRequiredBanner.description')
 * t('webedi:viewDocument.receiver.noActionRequiredBanner.title')
 * t('webedi:viewDocument.receiver.noActionRequiredBanner.description')
 */
